module.exports = __webpack_public_path__ + "img/pt16.185ee40a.png";